import React from 'react';
import InitPasswordForm from '../../components/forms/InitPasswordForm/InitPasswordForm';
import { APP_CONFIG } from '../../config/constants';
import './InitPasswordPage.css';
import logo from '../../assets/logo.png';

const InitPasswordPage = () => {
    return (
        <div className="init-password-page">
            <div
                className="background-logo"
                style={{
                    backgroundImage: `url(${logo})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    opacity: 0.30,
                    position: 'absolute',
                    inset: 0,
                    zIndex: 0,
                }}
            />
            <div className="init-password-container">
                <div className="init-password-header">
                    <h1>{APP_CONFIG.APP_NAME}</h1>
                    <p className="subtitle">ein Produkt der {APP_CONFIG.COMPANY_NAME}</p>
                </div>

                <div className="init-password-box">
                    <InitPasswordForm />
                </div>
            </div>
        </div>
    );
};

export default InitPasswordPage;